import React from 'react';
import {
  View,
  Image,
  StyleSheet,
  Text,
  ViewStyle,
  Pressable,
} from 'react-native';
import { transparent } from '../assets/style/colors';
import { Str_Reload } from '../language/string_res';
import FastImage from 'react-native-fast-image';

export type MediaType = 'image' | 'video';
export type MediaStatus = 'loading' | 'error';

interface MediaPlaceholderProps {
  /** 媒体类型 */
  type: MediaType;
  /** 媒体状态 */
  status: MediaStatus;
  /** 视频时长（秒） */
  duration?: number;
  /** 宽度 */
  width: number;
  /** 高度 */
  height: number;
  /** 填充 */
  marginVertical: number;
  // 点击事件
  onPress?: () => void;
  // 是否显示背景
  showBg?: boolean;
  // 是否显示重新加载提示
  showReroad?: boolean;
}

const MediaPlaceholder: React.FC<MediaPlaceholderProps> = ({
  type,
  status = 'loading',
  width,
  height,
  marginVertical = 0,
  onPress,
  showBg = true,
  showReroad = true,
}) => {
  const loadingWidth = width * 0.8;
  const loadingHeight = loadingWidth * 87 / 130;

  // 根据类型和状态获取占位符图标
  const getPlaceholderIcon = () => {
    if (status === 'error') {
      return type === 'image'
          ? require('../assets/image/ic_image_error.png')
        : require('../assets/image/ic_video_error.png');
    }
    return type === 'image'
        ? require('../assets/image/ic_image_placeholder.png')
        : require('../assets/image/ic_video_placeholder.png');
  };

  const imgWidth = Math.min(Math.max(width * 0.25, 20), 40);
  const imgHeight = Math.min(Math.max(height * 0.25, 20), 40);


  return (
    <Pressable style={[styles.container, {
      width: width,
      height: height,
      marginVertical: marginVertical,
      paddingBottom: showReroad ? 10 : 0,
      backgroundColor: showBg ? '#666666' : transparent,
    }]} onPress={onPress}>
      {/* 主占位符图标 */}
      {showBg &&
        <Image
          source={getPlaceholderIcon()}
          style={[styles.placeholderIcon, { width: imgWidth, height: imgHeight }]}
          resizeMode='contain'
        />
      }

      {showReroad && status === 'error' && (
        <View pointerEvents="none" style={[styles.errorOverlay, { backgroundColor: transparent, bottom: (height * 0.5 - imgHeight) - 10 }]}>
          <Text style={styles.errorText}>{Str_Reload} ↻</Text>
        </View>
      )}

      {/* 加载中动画 */}
      {status === 'loading' && (
        <View style={styles.loadingAnimationContainer}>
          <FastImage
            source={require('../assets/image/ic_animation_loading.gif')}
            style={{ width: loadingWidth, height: loadingHeight }}
            resizeMode="contain"
          />
        </View>
      )}
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  placeholderIcon: {
    opacity: 0.7,
  },
  loadingAnimationContainer: {
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
  },
  durationBadge: {
    position: 'absolute',
    bottom: 8,
    right: 8,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
  },
  durationText: {
    color: '#FFFFFF',
    fontSize: 12,
    fontWeight: '600',
  },
  errorOverlay: {
    position: 'absolute',
    left: 8,
    right: 8,
    backgroundColor: 'rgba(255, 0, 0, 0.7)',
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 4,
  },
  errorText: {
    color: '#FFFFFF',
    fontSize: 12,
    textAlign: 'center',
  },
});

export default MediaPlaceholder;
